//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.BaseBuilder.js";
import "../CAM/CAM.InheritableToolDepBuilder.js";
let d=[[[0,"DefaultRegionStartType",1,0],[1,"StartPointsEffectDistBuilder",0,"CAM.InheritableToolDepBuilder",0],[0,"StartPointsUseEffectDist",1,0]],[[["count","regionStartPoints"],"GetRegionStartPoints",{},0,0],[["regionStartPoints"],"SetRegionStartPoints",{},1,0]],[]];
SPLM.CAM.NcmSubopBuilder = class extends SPLM.CAM.BaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.NcmSubopBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.NcmSubopBuilder.DefaultRegionStartTypes = Object.freeze({
    "MidPoint" : "MidPoint", "Corner" : "Corner"});

SPLM.CAM.NcmSubopBuilder.TransferUsing = Object.freeze({
    "EngageRetract" : "EngageRetract", "FollowBoundary" : "FollowBoundary", "LiftPlunge" : "LiftPlunge", "None" : "None", "Smooth" : "Smooth"});

export default SPLM;